import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2011',
    ecrans: ['00-2'],
    params: ['id']
});
